export const DEFAULT_PAGE_SCHEMA = 'page-schema';
export const DEFAULT_SEOMATIC_SCHEMA = 'seomatic-schema';
export const EXERCISE_GRAPH_SCHEMA = 'exercise-graph-schema';

export const useSchema = () => {
  // Only run on server-side (SSR context)
  if (!import.meta.server) {
    return {
      registerComponentSchema: () => {},
      DEFAULT_PAGE_SCHEMA,
      DEFAULT_SEOMATIC_SCHEMA,
      EXERCISE_GRAPH_SCHEMA,
    };
  }

  const schemas = useState('schemas', () => ({}));
  const graphSchemas = useState('graphSchemas', () => ({}));

  const registerComponentSchema = (schema, componentId, isGraphSchema = false) => {
    // Early returns for invalid inputs
    if (!componentId || !schema) {
      return;
    }

    try {
      if (isGraphSchema) {
        if (!graphSchemas.value[componentId]) {
          graphSchemas.value[componentId] = [];
        }
        graphSchemas.value[componentId].push(schema);

        // Create graph schema directly
        const graphSchema = {
          '@context': 'https://schema.org',
          '@graph': graphSchemas.value[componentId],
        };
        schemas.value[componentId] = graphSchema;
      } else {
        schemas.value[componentId] = schema;
      }
    } catch (error) {
      console.warn('Error registering schema:', error);
    }
  };

  // Reactive useHead - updates automatically when schemas change
  useHead(() => {
    const schemaEntries = Object.entries(schemas.value);
    if (schemaEntries.length === 0) return { script: [] };

    const hasSeomaticData = schemas.value?.[DEFAULT_SEOMATIC_SCHEMA];
    const hasPageData = schemas.value?.[DEFAULT_PAGE_SCHEMA];

    const scripts = schemaEntries
      .filter(([componentId]) => {
        if (hasPageData && hasSeomaticData) {
          return componentId !== DEFAULT_SEOMATIC_SCHEMA;
        }
        return true;
      })
      .map(([componentId, schema]) => ({
        type: 'application/ld+json',
        'data-component': componentId,
        innerHTML: JSON.stringify(schema),
      }));

    return { script: scripts };
  });

  return {
    registerComponentSchema,
    DEFAULT_PAGE_SCHEMA,
    DEFAULT_SEOMATIC_SCHEMA,
    EXERCISE_GRAPH_SCHEMA,
  };
};
